<template>
  <v-dialog
    scrollable
    v-model="visible"
    max-width="900px"
    :fullscreen="fullscreen"
    :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">查看</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs10>
              <div class="x-text-field">
                <label>角色名称</label>
                <div>{{item.name}}</div>
              </div>
            </v-flex>

            <v-flex xs2>
              <div class="x-text-field">
                <label>禁用</label>
                <div>{{item.disabled ? '是' : '否'}}</div>
              </div>
            </v-flex>

            <v-flex xs12>
              <div class="x-text-field">
                <label>备注</label>
                <div>{{item.note}}</div>
              </div>
            </v-flex>

          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="primary" @click.native="visible=false">关闭</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import mixin from '@/mixin'

  const baseUri = '/api/syst/role';

  export default {
    mixins: [mixin.view(baseUri)],
    data() {
      return {
        item: {}
      }
    }
  }
</script>
